/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Box } from "@material-ui/core";
import { HOUR_UNTIL_PURCHASE_PHONE_CANCELED } from "constants/purchase";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";

import type { FC } from "react";

export const CarrierPaymentProcedureRequired: FC<{
  isDarkModeEnabled: boolean;
}> = ({ isDarkModeEnabled }) => {
  const { t } = useI18n();
  return (
    <Box
      component={"div"}
      display={"flex"}
      flexDirection={"column"}
      gridGap={"20px"}
    >
      <Box
        component={"h2"}
        fontWeight={"700"}
        textAlign={"center"}
        color={isDarkModeEnabled ? "#fff" : "#000"}
        lineHeight={"1.5em"}
        whiteSpace={"pre-wrap"}
      >
        {t("streaming.commerceModal.headline")}
      </Box>

      <Box
        component={"p"}
        fontSize={"14px"}
        lineHeight={"1.5em"}
        color={isDarkModeEnabled ? "#fff" : "#000"}
      >
        {t("streaming.commerceModal.para1", {
          displayTime: HOUR_UNTIL_PURCHASE_PHONE_CANCELED,
        })}
        <br />
        {t("streaming.commerceModal.para2")}
      </Box>

      <Box
        component={"p"}
        fontSize={"12px"}
        fontWeight={"700"}
        lineHeight={"1.5em"}
        color={isDarkModeEnabled ? "#fff" : "#000"}
      >
        {t("streaming.commerceModal.caution")}
      </Box>
    </Box>
  );
};
